import PropTypes from "prop-types";
import React, { useState } from "react";
import { format, parse, addDays } from "date-fns";
import { Popup, Button } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";

import { DateFormat } from "../helpers";
import { parseServerTimestampForClient } from "../../common/helpers";

const InvoiceComponentTimestamp = ({ invoiced_at, onChange, editable = true }) => {
    const [showPicker, setShowPicker] = useState(false);
    const handleDateChange = (e, data) => {
        data.value = parse(data.value, DateFormat, new Date());
        setShowPicker(false);
        onChange(e, data);
    };

    const formattedDate = format(parseServerTimestampForClient(invoiced_at), DateFormat);

    if (!editable) {
        return <Button compact size="mini" content={formattedDate} disabled />;
    }

    return (
        <Popup
            data-cy="invoice_timestamp_popup"
            on="click"
            open={showPicker}
            onClose={() => setShowPicker(false)}
            trigger={
                <Button
                    data-cy="invoice_timestamp"
                    compact
                    size="mini"
                    content={formattedDate}
                    onClick={() => setShowPicker(true)}
                />
            }
        >
            <DateInput
                inline
                initialDate={invoiced_at}
                onChange={handleDateChange}
                maxDate={addDays(new Date(), 10)}
                dateFormat={DateFormat.toUpperCase()}
                value={formattedDate}
            />
        </Popup>
    );
};

InvoiceComponentTimestamp.propTypes = {
    onChange: PropTypes.func,
    invoiced_at: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    editable: PropTypes.bool,
};

export default InvoiceComponentTimestamp;
